var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArgentina(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74acdf",
      stroke: "none"
    },
    d: "M0 0L0 8L50 8L50 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f3f8fc",
      stroke: "none"
    },
    d: "M0 8L0 17L50 17L50 8L0 8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#edd5b7",
      stroke: "none"
    },
    d: "M23.3326 10.0856C19.8572 12.1404 23.4338 16.8262 26.6674 14.9144C30.1428 12.8596 26.5662 8.17381 23.3326 10.0856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d2a66d",
      stroke: "none"
    },
    d: "M23.6427 11.0671C21.4527 12.6896 24.4036 15.3802 26.3573 13.9329C28.5473 12.3104 25.5964 9.61975 23.6427 11.0671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d99515",
      stroke: "none"
    },
    d: "M23 11L23 14L27 14L27 11L23 11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#74acdf",
      stroke: "none"
    },
    d: "M0 17L0 25L50 25L50 17L0 17z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgentina);
export default __webpack_public_path__ + "static/media/argentina.bff08d404f2baa236fa2b81185f556de.svg";
export { ForwardRef as ReactComponent };